import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    HostListener,
    TemplateRef,
    inject,
    input,
} from '@angular/core';
import { OverlayRef } from './overlay.ref';

@Component({
    selector: 'telxl-shared-overlay-modal',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    template: `
        <div>
            <div class="modal-backdrop overlay-backdrop show"></div>
            <div
                class="overlay modal d-flex justify-content-center align-items-center"
            >
                <div class="modal-dialog" [ngClass]="[size(), modalClass()]">
                    <div class="modal-content" [ngClass]="contentClass()">
                        @if (headerTemplate) {
                            <div class="modal-header" [ngClass]="headerClass()">
                                <ng-container
                                    *ngTemplateOutlet="headerTemplate"
                                ></ng-container>
                            </div>
                        }

                        @if (bodyTemplate) {
                            <div class="modal-body" [ngClass]="bodyClass()">
                                <ng-container
                                    *ngTemplateOutlet="bodyTemplate"
                                ></ng-container>
                            </div>
                        }

                        @if (footerTemplate) {
                            <div class="modal-footer" [ngClass]="footerClass()">
                                <ng-container
                                    *ngTemplateOutlet="footerTemplate"
                                ></ng-container>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    `,
    styleUrl: './overlay.component.scss',
})
export class TelXLOverlayComponent {
    readonly #overlayRef = inject(OverlayRef<void>);

    @ContentChild('modalBody', { static: true })
    bodyTemplate!: TemplateRef<unknown>;
    @ContentChild('modalFooter', { static: true })
    footerTemplate!: TemplateRef<unknown>;
    @ContentChild('modalHeader', { static: true })
    headerTemplate!: TemplateRef<unknown>;

    size = input<'sm' | 'md' | 'lg'>('md');
    modalClass = input<string>('');
    contentClass = input<string>('');
    headerClass = input<string>('');
    bodyClass = input<string>('');
    footerClass = input<string>('');

    onClose() {
        this.#overlayRef.close(undefined);
    }

    @HostListener('document:keydown', ['$event']) onKeydownHandler(
        event: KeyboardEvent,
    ) {
        if (event.key === 'Escape') {
            this.onClose();
        }
    }
}
